import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { colors } from '../../../styles/constants';
import { Dl, Dt, Dd } from '../../../components/DescriptionList/Horizontal';
import { OrderAddress } from '../../../types/checkout';
import Address from '../../../components/Address';
import StyledLink from '../../../components/StyledLink';

export interface FullAddressProps extends WithTranslation {
    address: OrderAddress;
}

const FullAddress = (
    {
        t,
        address,
    }: FullAddressProps
) => {
    return (
        <>
            <Address {...address} />
            {address.email && (
                <Dl>
                    <Dt doubleColumn>{t('payments.fields.email')}</Dt>
                    <Dd>{address.email}</Dd>
                </Dl>
            )}
            {address.phone_number && (
                <Dl>
                    <Dt doubleColumn>{t('payments.fields.phone_number')}</Dt>
                    <Dd>{address.phone_number}</Dd>
                </Dl>
            )}
            {address.latitude && address.longitude && (
                <Dl>
                    <Dt doubleColumn>{t('payments.fields.position')}</Dt>
                    <Dd>
                        <StyledLink
                            href={`https://www.google.com/maps/@?api=1&map_action=map&center=${address.latitude},${address.longitude}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {address.latitude},{address.longitude}
                        </StyledLink>
                    </Dd>
                </Dl>
            )}
            {address.comment && (
                <Dl>
                    <Dt doubleColumn>{t('payments.fields.comment')}</Dt>
                    <Dd>{address.comment}</Dd>
                </Dl>
            )}
        </>
    );
};

export default withTranslation()(FullAddress);
